import { jsx as t } from "react/jsx-runtime";
import { c as m } from "./clsx-OuTLNxxd.js";
const s = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function c({
  src: l,
  alt: a,
  width: o = "auto",
  borderRadius: e = "none",
  className: i = "",
  ...r
}) {
  const _ = m(s.img, i, s[d[o]], s[n[e]]);
  return /* @__PURE__ */ t("img", { ...r, className: _, alt: a, src: l });
}
const d = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, n = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
};
export {
  n as B,
  c as I,
  d as a
};
